import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=0b5181ad&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5181ad')) {
      api.createRecord('0b5181ad', component.options)
    } else {
      api.reload('0b5181ad', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=0b5181ad&", function () {
      api.rerender('0b5181ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WWMpi3zCEAy/JS/pricelisthelp.vue"
export default component.exports